export const GRAPHQLlocal = false

export const GRAPHQLserver = GRAPHQLlocal ? 'ws://127.0.0.1:3000/graphql' : 'wss://ergebnisdienst.stb.de/graphql'
